
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({
    
    totalItems: 0,
    itemActivo: null,

    setTotalItems: (value) => set({ totalItems: value }),
    setActivarItem: (value) => set({ itemActivo: value }),
    
});




export const useCarritoItemsStore = create()(
    devtools(
        storeApi
    )
)
